export const getEmptyConfigValidation = () => {
  return {
    isKilnConfigValid: false,
    details: {
      isKilnNameSetUp: false,
      areKilnDimensionsSetUp: false,
      isDriveNameSetUp: false,
      areDriveBoundariesSetUp: false,
      isMoreThanOneStation: false,
      areStationsNamesSetUp: false,
      areStationsBoundariesSetUp: false
    }
  }
}
